import { get } from 'svelte/store';
import { AppState } from '../etc/stores';
import { Container, Service } from './container';
import { Logger } from './logger';
export var SHOPIFY_LOCAL_STORAGE_KEYS;
(function (SHOPIFY_LOCAL_STORAGE_KEYS) {
    SHOPIFY_LOCAL_STORAGE_KEYS["EXTENSION_STORAGE"] = "extensionStorage";
})(SHOPIFY_LOCAL_STORAGE_KEYS || (SHOPIFY_LOCAL_STORAGE_KEYS = {}));
export const AUTH_STORAGE_FLAGS = {
    customerImport: 'twism-customer-import-auth',
    welcomeCoins: 'twism-free-coins-auth',
    referral: 'referred-redeem-auth',
    customerAcquisition: 'customer-acquisition-auth',
    fastRedemption: 'fast-redemption-auth'
};
export class SessionManager extends Service {
    constructor() {
        super(...arguments);
        this.logger = this.ctx.get(Logger).context(SessionManager.name);
    }
    set(name, value, options = {}) {
        const { business } = get(AppState);
        let saveOn = options.saveOn;
        delete options.saveOn;
        if (!saveOn)
            saveOn = options.expires ? 'localStorage' : 'sessionStorage';
        let valueData = {
            value,
            options
        };
        if (options.validBusiness) {
            valueData.value = {
                value: value,
                businessId: business.id
            };
        }
        const data = JSON.stringify(valueData);
        const key = this.getKey(name);
        if (saveOn === 'localStorage') {
            sessionStorage.removeItem(key);
            localStorage.setItem(key, data);
        }
        else {
            localStorage.removeItem(key);
            sessionStorage.setItem(key, data);
        }
    }
    get(name) {
        const key = this.getKey(name);
        const val = localStorage.getItem(key) || sessionStorage.getItem(key);
        if (!val) {
            return null;
        }
        try {
            const data = JSON.parse(val);
            const { business } = get(AppState);
            if (data.options.expires &&
                +new Date(data.options.expires) < Date.now()) {
                this.remove(name);
                return null;
            }
            if (data.options.validBusiness) {
                if (data.value.businessId !== business.id) {
                    this.remove(name);
                    return null;
                }
                return data.value.value;
            }
            return data.value;
        }
        catch (e) {
            this.logger.error(e);
            this.remove(name);
            return null;
        }
    }
    getRaw(name) {
        const key = name;
        const val = localStorage.getItem(key) || sessionStorage.getItem(key);
        return val ? val : null;
    }
    remove(name) {
        localStorage.removeItem(this.getKey(name));
        sessionStorage.removeItem(this.getKey(name));
    }
    removeRaw(name) {
        localStorage.removeItem(name);
        sessionStorage.removeItem(name);
    }
    setRaw(name, value, options = {}) {
        options.saveOn === 'localStorage'
            ? localStorage.setItem(name, value)
            : sessionStorage.setItem(name, value);
    }
    getKey(name) {
        return `twism__${name}`;
    }
}
Container.add(SessionManager);
